import { QUERY_CONFIGURATION_NOT_LOADED, useGetConfigQuery } from '@common/config';
import { Oauth2Config } from '../types/oauth2-config.type';

export function useOauth2Config() {
  const { data } = useGetConfigQuery();
  if (!data) throw QUERY_CONFIGURATION_NOT_LOADED;

  return { config: data as Oauth2Config };
}